module.exports = __webpack_public_path__ + "img/220.bfc9b602.jpg";